// extracted by mini-css-extract-plugin
module.exports = {"LargeImage":"LargeImage_LargeImage__2FH_N"};